import React from 'react';
import { connect } from 'react-redux';

import { CookieMain, CookieWrapper, ButtonWrapper, Title, Description, DescriptionWrapper, Close, Learn, Accept } from './Components';
import { setCookie, getCookie } from '../../../tools/cookies';
import { withAITracking } from 'react-appinsights';

import { IState } from '../../../reducers/index';
import { ICookiesReducer } from '../../../reducers/cookiesReducer';
import { IProfileReducer } from '../../../reducers/profileReducer';
import { IContextReducer } from '../../../reducers/contextReducer';
import * as cookiesActions from '../../../actions/cookiesAction';
import IntlMessage from '../../Common/IntlMessage';
import { ILanguageReducer } from '../../../reducers/languageReducer';

// tslint:disable-next-line: no-var-requires
const { reactAI } = require('react-appinsights');

export interface CookiesState {
    openLearn: boolean;
    openHeight: boolean;
    fadeOut: boolean;
}

type CookieProps = ICookiesReducer & IContextReducer & IProfileReducer & ILanguageReducer & typeof cookiesActions;

class Cookies extends React.Component<CookieProps, CookiesState> {

    componentWillMount() {
        reactAI?.setContext?.({ CorrelationId: `${this.props.currentUserProfile ? this.props.currentUserProfile.id : ''}`, ComponentName: 'Cookies', url: location.href });
    }

    componentDidMount() {
        this.checkCookie();
    }

    checkCookie = () => {
        const lcrCookie = getCookie('lcrCookie');
        if (lcrCookie === '') {
            this.props.showCookiesAction();
            this.props.blockCookieAction();
        } else {
            this.props.hideCookiesAction();
            this.props.unblockCookieAction();
        }
    }

    accept = () => {
        setCookie('lcrCookie', 'true', 395);
        this.props.unblockCookieAction();
        this.props.hideCookiesAction();
    }

    public render() {
        const { showCookie, isShadowAuth, translations } = this.props;
        return (
            <div>
                {(showCookie && !isShadowAuth && Object.keys(translations).length > 0) &&
                    <CookieMain >
                        <CookieWrapper >
                            <Close onClick={this.accept} />
                            <div>
                                <Title><IntlMessage id="cookies.privacy" /></Title>
                                <DescriptionWrapper>
                                    <Description>
                                        <IntlMessage id="cookies.message" />
                                        <button onClick={this.accept}>
                                            <Learn to={'/copyrights'}><IntlMessage id="cookies.button.learnMore" /></Learn>
                                        </button>
                                    </Description>
                                    <ButtonWrapper>
                                        <Accept onClick={this.accept}><IntlMessage id="cookies.button.accept" /></Accept>
                                    </ButtonWrapper>
                                </DescriptionWrapper>
                            </div>
                        </CookieWrapper>
                    </CookieMain>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IState) => ({
    ...state.cookies,
    ...state.context,
    ...state.profile,
    ...state.language
});

export default connect(mapStateToProps, cookiesActions)(withAITracking(Cookies));